import { helper } from '@ember/component/helper';

export function and(params /*, hash*/) {
    let passes = true;

    for (let i = 0; i < params.length; i++) {
        if (!params[i]) {
            passes = false;
            break;
        }
    }

    return passes;
}

export default helper(and);
